import type { UserRepository } from '../repository/UserRepository';
import type { GetUserRequest, GetUserResponse } from '../entity/UserTypes';

export class GetUserUseCase {
  constructor(private readonly repository: UserRepository) {}

  async execute(request: GetUserRequest): Promise<GetUserResponse> {
    if (!request.user_id?.trim()) {
      throw new Error('user_id는 필수입니다.');
    }
    return this.repository.getUser(request);
  }
}

